import { render, staticRenderFns } from "./remoteControl.vue?vue&type=template&id=0f0eda62&scoped=true&"
import script from "./remoteControl.vue?vue&type=script&lang=js&"
export * from "./remoteControl.vue?vue&type=script&lang=js&"
import style0 from "./remoteControl.vue?vue&type=style&index=0&id=0f0eda62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0eda62",
  null
  
)

export default component.exports